import * as React from 'react'
import { TaskSizesMain } from './TaskSizesMain'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskSizesMainExamples = () => {
  return (
    <div className="TaskSizesMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskSizesMain />
      </Provider>
    </div>
  )
}
